import { render, staticRenderFns } from "./En_footer.vue?vue&type=template&id=5b1317e0"
import script from "./En_footer.vue?vue&type=script&lang=js"
export * from "./En_footer.vue?vue&type=script&lang=js"
import style0 from "./En_footer.vue?vue&type=style&index=0&id=5b1317e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports